import React from "react";

export const InfoIcon = () => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.99999 17.3307C4.39749 17.3307 0.666656 13.5999 0.666656 8.9974C0.666656 4.3949 4.39749 0.664062 8.99999 0.664062C13.6025 0.664062 17.3333 4.3949 17.3333 8.9974C17.3333 13.5999 13.6025 17.3307 8.99999 17.3307ZM8.99999 15.6641C10.7681 15.6641 12.4638 14.9617 13.714 13.7114C14.9643 12.4612 15.6667 10.7655 15.6667 8.9974C15.6667 7.22929 14.9643 5.53359 13.714 4.28335C12.4638 3.03311 10.7681 2.33073 8.99999 2.33073C7.23188 2.33073 5.53619 3.03311 4.28594 4.28335C3.0357 5.53359 2.33332 7.22929 2.33332 8.9974C2.33332 10.7655 3.0357 12.4612 4.28594 13.7114C5.53619 14.9617 7.23188 15.6641 8.99999 15.6641ZM8.16666 4.83073H9.83332V6.4974H8.16666V4.83073ZM8.16666 8.16406H9.83332V13.1641H8.16666V8.16406Z"
          fill="#3A94FF"
          style={{
            fill: "#3A94FF",
            fill: "color(display-p3 0.2294 0.5816 0.9983)",
            fillOpacity: 1,
          }}
        />
      </svg>
    </>
  );
};
export const NicknameInfoIcon = (props) => {
  return (
    <>
      <svg
        width={15}
        height={15}
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_3957_147924)">
          <path
            d="M7.5 15C3.35775 15 0 11.6423 0 7.5C0 3.35775 3.35775 0 7.5 0C11.6423 0 15 3.35775 15 7.5C15 11.6423 11.6423 15 7.5 15ZM7.5 13.5C9.0913 13.5 10.6174 12.8679 11.7426 11.7426C12.8679 10.6174 13.5 9.0913 13.5 7.5C13.5 5.9087 12.8679 4.38258 11.7426 3.25736C10.6174 2.13214 9.0913 1.5 7.5 1.5C5.9087 1.5 4.38258 2.13214 3.25736 3.25736C2.13214 4.38258 1.5 5.9087 1.5 7.5C1.5 9.0913 2.13214 10.6174 3.25736 11.7426C4.38258 12.8679 5.9087 13.5 7.5 13.5ZM6.75 3.75H8.25V5.25H6.75V3.75ZM6.75 6.75H8.25V11.25H6.75V6.75Z"
            fill="#FCB451"
            style={{
              fill: "#FCB451",
              fill: "color(display-p3 0.9882 0.7059 0.3176)",
              fillOpacity: 1,
            }}
          />
        </g>
        <defs>
          <clipPath id="clip0_3957_147924">
            <rect
              width={15}
              height={15}
              fill="white"
              style={{
                fill: "white",
                fillOpacity: 1,
              }}
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
